import { useQuery } from 'react-query';

import { getV2ApiCompanyIdSpendLimits } from 'src/client/spendesk-api';
import { type QueryState } from 'src/core/api/queryState';
import { mapQueryResultToQueryState } from 'src/core/api/utils/queryState';

import { useCompany } from '../../app/hooks/useCompany';
import {
  mapSpendLimitResponseToSpendLimit,
  type SpendLimit,
} from '../models/spendLimit';

export const useSpendLimitsQuery = (): QueryState<SpendLimit[]> => {
  const company = useCompany();

  const result = useQuery(
    ['spend-limits'],
    async (): Promise<SpendLimit[]> => {
      const { body, statusCode } = await getV2ApiCompanyIdSpendLimits({
        path: { companyId: company.id },
      });
      if (statusCode !== 200) {
        throw new Error('Failed to fetch spend limits');
      }
      return body.map(mapSpendLimitResponseToSpendLimit);
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
    },
  );
  return mapQueryResultToQueryState(result);
};
